<template>
  <div class="aparelhos-container">
    <!-- ✅ HEADER PRINCIPAL (mantido igual) -->
    <div class="page-header">
        <div class="d-flex align-center flex-column flex-sm-row">
          <v-avatar size="48" color="blue-darken-1" class="mr-4 mb-2 mb-sm-0">
            <v-icon color="white" size="28">mdi-devices</v-icon>
          </v-avatar>
          <div class="text-center text-sm-start">
            <h1 class="text-h4 font-weight-bold text-blue-darken-1">Consulta de Aparelhos</h1>
          </div>
        
          <v-spacer></v-spacer>
        <v-btn
          color="grey"
          variant="outlined"
          @click="voltarMenu"
          class="back-btn"
        >
          <v-icon start>mdi-arrow-left</v-icon>
          Voltar ao Menu
        </v-btn>


      </div>
    </div>



    <!-- ✅ MODAL PARA EXIBIR FOTOS DO TIPO DE APARELHO -->
<v-dialog v-model="fotosModalVisible" max-width="1000" persistent scrollable>
  <v-card v-if="tipoAparelhoSelecionado">
    <!-- Header do Modal -->
    <v-card-title class="photos-modal-header pa-4 bg-purple text-white">
      <div class="d-flex align-center w-100">
        <v-avatar size="48" color="white" class="mr-4">
          <v-icon color="purple" size="24">mdi-camera</v-icon>
        </v-avatar>
        <div class="flex-grow-1">
          <div class="text-h5 font-weight-bold">
            {{ tipoAparelhoSelecionado.descricao_tipo || 'Fotos do Tipo' }}
          </div>
          <div class="text-body-2 opacity-90">
            Aparelho: {{ tipoAparelhoSelecionado.aparelho_atual?.descricao_aparelho }}
          </div>
        </div>
        <v-btn
          icon
          variant="text"
          color="white"
          @click="fecharModalFotos"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card-title>

    <v-divider></v-divider>

    <!-- Conteúdo do Modal -->
    <v-card-text class="pa-6">
      <!-- Informações do Tipo -->
      <v-row class="mb-4" v-if="tipoAparelhoSelecionado.fornecedor || tipoAparelhoSelecionado.observacao">
        <v-col cols="12">
          <v-card variant="outlined" class="info-card">
            <v-card-text class="pa-4">
              <v-row>
                <v-col cols="12" md="6" v-if="tipoAparelhoSelecionado.fornecedor">
                  <div class="detail-label">Fornecedor</div>
                  <div class="detail-value">
                    {{ tipoAparelhoSelecionado.fornecedor }}
                  </div>
                </v-col>
                <v-col cols="12" md="6" v-if="tipoAparelhoSelecionado.observacao">
                  <div class="detail-label">Observação</div>
                  <div class="detail-value">
                    {{ tipoAparelhoSelecionado.observacao }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Fotos -->
      <v-row>
        <v-col cols="12">
          <div class="text-h6 font-weight-bold mb-4">
            <v-icon color="purple" class="mr-2">mdi-image-multiple</v-icon>
            Galeria de Fotos
          </div>
        </v-col>

        <!-- Foto 1 -->
        <v-col cols="12" md="6">
          <div class="photo-section">
            <h4 class="mb-3 d-flex align-center">
              <v-icon color="purple" class="mr-2">mdi-numeric-1-circle</v-icon>
              Foto Principal
            </h4>
            <ImagemTipoAparelho
              :imagem-base64="tipoAparelhoSelecionado.foto1"
              alt="Foto principal do tipo de aparelho"
              :loading="loadingFotos[tipoAparelhoSelecionado.id_tipo_aparelho] === true"
              :mostrar-detalhes="true"
              mensagem-sem-imagem="Foto principal não disponível"
            />
          </div>
        </v-col>

        <!-- Foto 2 -->
        <v-col cols="12" md="6">
          <div class="photo-section">
            <h4 class="mb-3 d-flex align-center">
              <v-icon color="purple" class="mr-2">mdi-numeric-2-circle</v-icon>
              Foto Secundária
            </h4>
            <ImagemTipoAparelho
              :imagem-base64="tipoAparelhoSelecionado.foto2"
              alt="Foto secundária do tipo de aparelho"
              :loading="loadingFotos[tipoAparelhoSelecionado.id_tipo_aparelho] === true"
              :mostrar-detalhes="true"
              mensagem-sem-imagem="Foto secundária não disponível"
            />
          </div>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <!-- Ações do Modal -->
    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn
        color="grey"
        variant="outlined"
        @click="fecharModalFotos"
      >
        <v-icon start>mdi-close</v-icon>
        Fechar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>



<!-- ✅ FILTROS EXPANSÍVEIS OTIMIZADOS - CONTROLES NO HEADER -->
<v-card class="filters-card" elevation="2">
  <v-card-title class="filters-header pa-4">
    <div class="d-flex align-center w-100">
      <!-- ✅ SEÇÃO ESQUERDA - TÍTULO E INFORMAÇÕES -->
      <div class="d-flex align-center cursor-pointer flex-grow-1" @click="toggleFilters">
        <v-icon class="mr-2" color="white">mdi-filter-variant</v-icon>
        <span class="filters-title"></span>
        
        <!-- Chips de Status - Responsivos -->
        <div class="d-flex align-center gap-2 ml-4" :class="{ 'd-none d-sm-flex': isMobile }">
          <v-chip variant="tonal" size="small">
            {{ filteredAparelhos.length }} aparelhos
          </v-chip>
          
          <v-chip 
            v-if="hasActiveFilters"
            color="warning" 
            variant="tonal" 
            size="small"
          >
            {{ activeFiltersCount }} filtro(s)
          </v-chip>
        </div>
      </div>
      
      <!-- ✅ SEÇÃO CENTRAL - CONTROLES DE AÇÃO RESPONSIVOS -->
      <div class="controls-section" :class="{ 'mobile-controls': isMobile }">
        <!-- Desktop Controls -->
        <div v-if="!isMobile" class="d-flex align-center gap-3 mr-4">
          <!-- Botão Atualizar -->
          <v-btn
            color="white"
            variant="flat"
            size="small"
            @click="fetchData"
            :loading="loadingDialog"
            class="compact-btn"
          >
            <v-icon size="18" color="grey-darken-2">mdi-refresh</v-icon>
            <span class="ml-2 text-grey-darken-2">Atualizar</span>
          </v-btn>
          
          <!-- Botão Limpar Filtros -->
          <v-btn
            color="white"
            variant="flat"
            size="small"
            @click="limparFiltros"
            :disabled="!hasActiveFilters"
            class="compact-btn"
          >
            <v-icon size="18" :color="hasActiveFilters ? 'grey-darken-2' : 'grey-lighten-1'">mdi-filter-off</v-icon>
            <span class="ml-2" :class="hasActiveFilters ? 'text-grey-darken-2' : 'text-grey-lighten-1'">Limpar</span>
          </v-btn>

          <!-- Toggle de Visualização -->
          <v-btn-toggle
            v-model="viewMode"
            mandatory
            variant="outlined"
            divided
            size="small"
            class="compact-toggle ml-2"
            color="grey-darken-2"
          >
            <v-btn value="table" size="small">
              <v-icon size="18">mdi-table</v-icon>
              <v-tooltip activator="parent">Visualização em Tabela</v-tooltip>
            </v-btn>
            <v-btn value="cards" size="small">
              <v-icon size="18">mdi-view-grid</v-icon>
              <v-tooltip activator="parent">Visualização em Cards</v-tooltip>
            </v-btn>
          </v-btn-toggle>
        </div>

        <!-- Mobile Controls -->
        <div v-else class="d-flex align-center gap-2">
          <!-- Botão Atualizar Mobile -->
          <v-btn
            color="white"
            variant="flat"
            size="x-small"
            @click="fetchData"
            :loading="loadingDialog"
            class="mobile-btn"
            icon
          >
            <v-icon size="16" color="grey-darken-2">mdi-refresh</v-icon>
            <v-tooltip activator="parent">Atualizar</v-tooltip>
          </v-btn>
          
          <!-- Botão Limpar Filtros Mobile -->
          <v-btn
            color="white"
            variant="flat"
            size="x-small"
            @click="limparFiltros"
            :disabled="!hasActiveFilters"
            class="mobile-btn"
            icon
          >
            <v-icon size="16" :color="hasActiveFilters ? 'grey-darken-2' : 'grey-lighten-1'">mdi-filter-off</v-icon>
            <v-tooltip activator="parent">Limpar Filtros</v-tooltip>
          </v-btn>

          <!-- Menu de Visualização Mobile -->
          <v-menu offset-y>
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                color="white"
                variant="flat"
                size="x-small"
                class="mobile-btn"
                icon
              >
                <v-icon size="16" color="grey-darken-2">{{ viewMode === 'table' ? 'mdi-table' : 'mdi-view-grid' }}</v-icon>
                <v-tooltip activator="parent">Modo de Visualização</v-tooltip>
              </v-btn>
            </template>
            <v-list density="compact" class="mobile-menu">
              <v-list-item @click="viewMode = 'table'" :class="{ 'v-list-item--active': viewMode === 'table' }">
                <template v-slot:prepend>
                  <v-icon size="18">mdi-table</v-icon>
                </template>
                <v-list-item-title>Tabela</v-list-item-title>
              </v-list-item>
              <v-list-item @click="viewMode = 'cards'" :class="{ 'v-list-item--active': viewMode === 'cards' }">
                <template v-slot:prepend>
                  <v-icon size="18">mdi-view-grid</v-icon>
                </template>
                <v-list-item-title>Cards</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      
      <!-- ✅ SEÇÃO DIREITA - BOTÃO DE EXPANDIR -->
      <v-btn
        icon
        variant="text"
        :size="isMobile ? 'x-small' : 'small'"
        color="white"
        class="expand-btn ml-2"
        @click="toggleFilters"
      >
        <v-icon :size="isMobile ? 16 : 20" :class="{ 'rotate-180': filtersExpanded }">
          mdi-chevron-down
        </v-icon>
        <v-tooltip activator="parent">
          {{ filtersExpanded ? 'Recolher Filtros' : 'Expandir Filtros' }}
        </v-tooltip>
      </v-btn>
    </div>

    <!-- ✅ CHIPS DE STATUS MOBILE (abaixo do header) -->
    <div v-if="isMobile" class="mobile-status-chips pa-2 pt-0">
      <div class="d-flex align-center flex-wrap gap-1">
        <v-chip variant="tonal" size="x-small" color="blue-grey">
          {{ filteredAparelhos.length }} aparelhos
        </v-chip>
        
        <v-chip 
          v-if="hasActiveFilters"
          color="warning" 
          variant="tonal" 
          size="x-small"
        >
          {{ activeFiltersCount }} filtro(s)
        </v-chip>
      </div>
    </div>
  </v-card-title>
  
  <!-- ✅ CONTEÚDO EXPANSÍVEL DOS FILTROS -->
  <v-expand-transition>
    <div v-show="filtersExpanded">
      <v-divider></v-divider>
      
      <v-card-text class="pa-4">
        <v-row>
          <!-- Campo de Busca -->
          <v-col cols="12" md="2">
            <v-text-field
              v-model="search"
              label="Buscar aparelhos..."
              placeholder="Digite ID, descrição, marca, modelo..."
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              clearable
              hide-details
              density="compact"
              class="search-field"
            >
              <template v-slot:append-inner>
                <v-tooltip text="Busque por ID, descrição, marca, modelo ou número de série">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" size="18" color="grey">mdi-help-circle-outline</v-icon>
                  </template>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-col>

          <!-- Filtros -->
          <v-col cols="12" md="2">
            <v-select
              v-model="filtroIdTipoAparelho"
              :items="idsTipoAparelho"
              label="ID Tipo Aparelho"
              variant="outlined"
              clearable
              hide-details
              density="compact"
              prepend-inner-icon="mdi-identifier"
            ></v-select>
          </v-col>
          
          <v-col cols="12" md="2">
            <v-select
              v-model="filtroTipoAparelho"
              :items="tiposDeAparelho"
              label="Tipo de Aparelho"
              variant="outlined"
              clearable
              hide-details
              density="compact"
              prepend-inner-icon="mdi-router-wireless"
            ></v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-select
              v-model="filtroTipoMaquina"
              :items="tiposDeMaquina"
              label="Tipo de Máquina"
              variant="outlined"
              clearable
              hide-details
              density="compact"
              prepend-inner-icon="mdi-cog"
            ></v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-select
              v-model="filtroDisponivel"
              :items="[
                { title: 'Disponível', value: 'SIM' },
                { title: 'Indisponível', value: 'NAO' }
              ]"
              item-title="title"
              item-value="value"
              label="Status"
              variant="outlined"
              clearable
              hide-details
              density="compact"
              prepend-inner-icon="mdi-check-circle"
            ></v-select>
          </v-col>

          <v-col cols="12" md="2">
            <v-select
              v-model="filtroSetor"
              :items="setores"
              label="Setor"
              variant="outlined"
              clearable
              hide-details
              density="compact"
              prepend-inner-icon="mdi-domain"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-expand-transition>
  
  <!-- ✅ BARRA DE FILTROS RÁPIDOS (quando recolhido) -->
  <div v-if="!filtersExpanded && hasActiveFilters" class="quick-filters-bar">
    <v-divider></v-divider>
    <div class="pa-3">
      <div class="d-flex align-center flex-wrap gap-2">
        <span class="text-caption text-grey mr-2">Filtros ativos:</span>
        
        <!-- Chips de filtros ativos -->
        <v-chip
          v-if="search"
          color="primary"
          variant="tonal"
          :size="isMobile ? 'x-small' : 'small'"
          closable
          @click:close="search = ''"
        >
          <v-icon start :size="isMobile ? 12 : 14">mdi-magnify</v-icon>
          "{{ search }}"
        </v-chip>
        
        <v-chip
          v-if="filtroIdTipoAparelho"
          color="indigo"
          variant="tonal"
          :size="isMobile ? 'x-small' : 'small'"
          closable
          @click:close="filtroIdTipoAparelho = null"
        >
          <v-icon start :size="isMobile ? 12 : 14">mdi-identifier</v-icon>
          ID Tipo: {{ filtroIdTipoAparelho }}
        </v-chip>
        
        <v-chip
          v-if="filtroTipoAparelho"
          color="blue-grey"
          variant="tonal"
          :size="isMobile ? 'x-small' : 'small'"
          closable
          @click:close="filtroTipoAparelho = null"
        >
          <v-icon start :size="isMobile ? 12 : 14">mdi-router-wireless</v-icon>
          {{ filtroTipoAparelho }}
        </v-chip>
        
        <v-chip
          v-if="filtroTipoMaquina"
          color="orange-darken-1"
          variant="tonal"
          :size="isMobile ? 'x-small' : 'small'"
          closable
          @click:close="filtroTipoMaquina = null"
        >
          <v-icon start :size="isMobile ? 12 : 14">mdi-cog</v-icon>
          {{ filtroTipoMaquina }}
        </v-chip>
        
        <v-chip
          v-if="filtroDisponivel"
          :color="filtroDisponivel === 'SIM' ? 'success' : 'error'"
          variant="tonal"
          :size="isMobile ? 'x-small' : 'small'"
          closable
          @click:close="filtroDisponivel = null"
        >
          <v-icon start :size="isMobile ? 12 : 14">mdi-check-circle</v-icon>
          {{ filtroDisponivel === 'SIM' ? 'Disponível' : 'Indisponível' }}
        </v-chip>
        
        <v-chip
          v-if="filtroSetor"
          color="green-darken-1"
          variant="tonal"
          :size="isMobile ? 'x-small' : 'small'"
          closable
          @click:close="filtroSetor = null"
        >
          <v-icon start :size="isMobile ? 12 : 14">mdi-domain</v-icon>
          {{ filtroSetor }}
        </v-chip>
        
        <v-spacer></v-spacer>
        
        <v-btn
          color="warning"
          variant="text"
          :size="isMobile ? 'x-small' : 'small'"
          @click="limparFiltros"
        >
          <v-icon start :size="isMobile ? 12 : 14">mdi-close</v-icon>
          <span v-if="!isMobile">Limpar Tudo</span>
        </v-btn>
      </div>
    </div>
  </div>
</v-card>

    <!-- ✅ CONTEÚDO PRINCIPAL -->
    <div v-if="!loadingDialog" class="content-area" :class="{ 'expanded': !filtersExpanded }">
      <!-- ✅ VISUALIZAÇÃO EM TABELA (Desktop) - CONFIGURAÇÃO CORRIGIDA -->
      <v-card v-if="!isMobile && viewMode === 'table'" class="table-card" elevation="2">
        <v-data-table
          :headers="headers"
          :items="filteredAparelhos"
           class="elevation-0"
          item-key="id_aparelho"
        >
          <template v-slot:item.id_aparelho="{ item }">
            <v-chip color="blue-darken-1" variant="tonal" size="small">
              APR{{ formatId(item.id_aparelho) }}
            </v-chip>
          </template>


          <template v-slot:item.id_tipo_aparelho="{ item }">
            <v-chip color="blue" variant="tonal" size="small">
            {{ item.id_tipo_aparelho }}
            </v-chip>
          </template>


          <template v-slot:item.descricao_aparelho="{ item }">
            <v-chip color="blue-darken-1" variant="tonal" size="small">
            {{ item.descricao_aparelho }}
            </v-chip>
          </template>

          <template v-slot:item.tipo_aparelho="{ item }">
            <v-chip color="cyan-darken-1" variant="tonal" size="small">
              {{ item.tipo_aparelho || "Não especificado" }}
            </v-chip>
          </template>

          <template v-slot:item.disponivel="{ item }">
            <v-chip 
              :color="item.disponivel === 'SIM' ? 'success' : 'error'"
              variant="flat"
              size="small"
            >
              <v-icon start size="16">
                {{ item.disponivel === 'SIM' ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
              {{ item.disponivel === 'SIM' ? 'Disponível' : 'Indisponível' }}
            </v-chip>
          </template>

          <template v-slot:item.id_maquina="{ item }">
            <div v-if="item.id_maquina" class="d-flex align-center">
              <v-icon size="16" class="mr-1" color="blue-darken-1">mdi-cog</v-icon>
              MAQ{{ formatId(item.id_maquina) }}
            </div>
            <span v-else class="text-grey">Sem máquina</span>
          </template>

          <template v-slot:item.setor="{ item }">
            <v-chip color="green-darken-1" variant="tonal" size="small">
              {{ item.setor || "Não especificado" }}
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="d-flex gap-1">

              <v-btn
                v-if="item.id_tipo_aparelho"
                icon
                size="small"
                color="purple"
                variant="tonal"
                @click="verFotosTipoAparelho(item)"
                :loading="loadingFotos[item.id_tipo_aparelho] === true"
              >
                <v-icon size="18">mdi-camera</v-icon>
                <v-tooltip activator="parent">Ver Fotos do Tipo</v-tooltip>
              </v-btn>



              <v-btn
                v-if="item.id_maquina"
                icon
                size="small"
                color="primary"
                variant="tonal"
                @click="openMachineModal(item)"
              >
                <v-icon size="18">mdi-eye</v-icon>
                <v-tooltip activator="parent">Ver Máquina</v-tooltip>
              </v-btn>
              
              <v-btn
                icon
                size="small"
                color="info"
                variant="tonal"
                @click="openDeviceModal(item)"
              >
                <v-icon size="18">mdi-information</v-icon>
                <v-tooltip activator="parent">Detalhes do Aparelho</v-tooltip>
              </v-btn>
            </div>
          </template>


        </v-data-table>
      </v-card>
<!-- ✅ VISUALIZAÇÃO EM CARDS (Mobile e Desktop) - COM PAGINAÇÃO MELHORADA -->
<div v-if="isMobile || viewMode === 'cards'" class="cards-container">
  <!-- ✅ INDICADOR DE PÁGINA NO TOPO (MOBILE) -->
  <div v-if="isMobile && filteredAparelhos.length > itemsPerPage" class="mobile-page-indicator mb-4">
    <v-card class="page-info-card" elevation="1">
      <v-card-text class="pa-3">
        <div class="d-flex align-center justify-space-between">
          <div class="page-info">
            <v-icon color="blue-darken-1" class="mr-2">mdi-view-grid</v-icon>
            <span class="text-body-2 font-weight-medium">
              Página {{ currentPage }} de {{ totalPages }}
            </span>
          </div>
          <div class="page-count">
            <v-chip color="blue-darken-1" variant="tonal" size="small">
              {{ startCardItem }}-{{ endCardItem }} de {{ filteredAparelhos.length }}
            </v-chip>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>

  <!-- ✅ NAVEGAÇÃO RÁPIDA (MOBILE) -->
  <div v-if="isMobile && filteredAparelhos.length > itemsPerPage" class="mobile-quick-nav mb-4">
    <div class="d-flex align-center justify-space-between gap-2">
      <v-btn
        :disabled="currentPage === 1"
        color="blue-darken-1"
        variant="tonal"
        size="small"
        @click="currentPage--"
        class="flex-grow-1"
      >
        <v-icon start>mdi-chevron-left</v-icon>
        Anterior
      </v-btn>
      
      <v-chip color="blue-darken-1" variant="flat" class="px-4">
        {{ currentPage }}/{{ totalPages }}
      </v-chip>
      
      <v-btn
        :disabled="currentPage === totalPages"
        color="blue-darken-1"
        variant="tonal"
        size="small"
        @click="currentPage++"
        class="flex-grow-1"
      >
        Próxima
        <v-icon end>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>

  <!-- ✅ ÁREA DE SCROLL DOS CARDS -->
  <div class="cards-scroll-area" :style="{ maxHeight: dynamicCardsHeight }">
    <v-row>
      <v-col
        v-for="aparelho in paginatedCardItems"
        :key="aparelho.id_aparelho"
        cols="12"
        :sm="viewMode === 'cards' ? 12 : 6"
        :md="viewMode === 'cards' ? 6 : 6"
        :lg="viewMode === 'cards' ? 4 : 6"
      >
        <v-card class="device-card" elevation="3" hover>
          <!-- Header do Card -->
          <v-card-title class="device-card-header pa-4">
            <div class="d-flex align-center w-100">
              <v-avatar size="40" color="white" variant="tonal" class="mr-3">
                <v-icon color="white">mdi-router-wireless</v-icon>
              </v-avatar>
              <div class="flex-grow-1">
                <div class="text-h6 font-weight-bold">{{ aparelho.descricao_aparelho }}</div>
                <v-chip color="blue-darken-1" variant="tonal" size="x-small" class="mt-1">
                  APR{{ formatId(aparelho.id_aparelho) }}  - Tipo: {{ aparelho.id_tipo_aparelho }}
                </v-chip>
              </div>
              <v-chip 
                :color="aparelho.disponivel === 'SIM' ? 'success' : 'error'"
                variant="flat"
                size="small"
              >
                {{ aparelho.disponivel === 'SIM' ? 'Disponível' : 'Indisponível' }}
              </v-chip>
            </div>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Conteúdo do Card -->
          <v-card-text class="pa-4">
            <v-row dense class="gy-4">
              <!-- Tipo de Aparelho -->
              <v-col cols="12" class="info-item">
                <div class="info-label">
                  <v-icon size="16" class="mr-1" color="cyan-darken-1">mdi-router-wireless</v-icon>
                  Tipo de Aparelho
                </div>
                <div class="info-value">
                  <v-chip color="cyan-darken-1" variant="tonal" size="small">
                    {{ aparelho.tipo_aparelho || "Não especificado" }}
                  </v-chip>
                </div>
              </v-col>

              <!-- Marca e Modelo -->
              <v-col cols="12" sm="6" class="info-item">
                <div class="info-label">
                  <v-icon size="16" class="mr-1" color="orange-darken-1">mdi-tag</v-icon>
                  Marca
                </div>
                <div class="info-value">{{ aparelho.marca || "Não informado" }}</div>
              </v-col>

              <v-col cols="12" sm="6" class="info-item">
                <div class="info-label">
                  <v-icon size="16" class="mr-1" color="teal-darken-1">mdi-tag-outline</v-icon>
                  Modelo
                </div>
                <div class="info-value">{{ aparelho.modelo || "Não informado" }}</div>
              </v-col>

              <!-- Número de Série -->
              <v-col cols="12" class="info-item">
                <div class="info-label">
                  <v-icon size="16" class="mr-1" color="indigo-darken-1">mdi-identifier</v-icon>
                  Número de Série
                </div>
                <div class="info-value">{{ aparelho.numero_serie || "Não informado" }}</div>
              </v-col>

              <!-- Informações da Máquina (se houver) -->
              <template v-if="aparelho.id_maquina">
                <v-col cols="12" class="machine-info-section">
                  <v-divider class="my-4"></v-divider>
                  <div class="text-subtitle-2 font-weight-bold text-blue-darken-1 mb-2">
                    <v-icon size="16" class="mr-1">mdi-cog</v-icon>
                    Máquina Vinculada
                  </div>
                </v-col>

                <v-col cols="12" sm="6" class="info-item">
                  <div class="info-label">
                    <v-icon size="16" class="mr-1" color="blue-darken-1">mdi-identifier</v-icon>
                    ID da Máquina
                  </div>
                  <div class="info-value">
                    <v-chip color="blue-darken-1" variant="tonal" size="small">
                      MAQ{{ formatId(aparelho.id_maquina) }}
                    </v-chip>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" class="info-item">
                  <div class="info-label">
                    <v-icon size="16" class="mr-1" color="green-darken-1">mdi-domain</v-icon>
                    Setor
                  </div>
                  <div class="info-value">
                    <v-chip color="green-darken-1" variant="tonal" size="small">
                      {{ aparelho.setor || "Não especificado" }}
                    </v-chip>
                  </div>
                </v-col>

                <v-col v-if="aparelho.fila || aparelho.posicao" cols="12" class="info-item">
                  <div class="info-label">
                    <v-icon start size="16" color="blue-darken-1">mdi-map-marker</v-icon>
                    Localização
                  </div>
                  <div class="info-value">
                    <v-chip color="blue-darken-1" variant="tonal" size="small">
                      Fila {{ aparelho.fila || "-" }} / Posição {{ aparelho.posicao || "-" }}
                    </v-chip>
                  </div>
                </v-col>
              </template>

              <!-- Sem Máquina Associada -->
              <template v-else>
                <v-col cols="12" class="text-center pa-4">
                  <v-avatar size="48" color="grey-lighten-3" class="mb-2">
                    <v-icon size="24" color="grey">mdi-link-off</v-icon>
                  </v-avatar>
                  <div class="text-body-2 text-grey">Sem máquina associada</div>
                </v-col>
              </template>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Ações do Card -->
          <v-card-actions class="pa-4 d-flex justify-space-between">


    <!-- ✅ BOTÃO PARA VER FOTOS -->
    <v-btn
      v-if="aparelho.id_tipo_aparelho"
      color="purple"
      variant="flat"
      size="small"
      @click="verFotosTipoAparelho(aparelho)"
      :loading="loadingFotos[aparelho.id_tipo_aparelho] === true"
      class="mb-2"
    >
      <v-icon start size="18">mdi-camera</v-icon>
      Ver Fotos
    </v-btn>


            <v-btn
              v-if="aparelho.id_maquina"
              color="primary"
              variant="flat"
              size="small"
              @click="openMachineModal(aparelho)"
              class="mb-2"
            >
              <v-icon start size="18">mdi-eye</v-icon>Ver Máquina</v-btn
            ><v-btn
              color="info"
              variant="outlined"
              size="small"
              @click="openDeviceModal(aparelho)"
            >
              <v-icon start size="18">mdi-information</v-icon>Detalhes do Aparelho
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>

</div>

<!-- ✅ BARRA DE NAVEGAÇÃO FIXA NO FOOTER (APENAS PARA MODO CARDS) -->
<div v-if="filteredAparelhos.length > itemsPerPage && viewMode === 'cards'" class="fixed-pagination-footer">
  <v-card class="pagination-card" elevation="4">
    <v-card-text class="pa-3">
      <!-- Botões de Navegação -->
      <div class="d-flex align-center justify-space-between">
        <v-btn
          :disabled="currentPage === 1"
          color="blue-darken-1"
          variant="flat"
          :size="isMobile ? 'small' : 'default'"
          @click="currentPage = 1"
          class="nav-btn"
        >
          <v-icon>mdi-page-first</v-icon>
        </v-btn>
        
        <v-btn
          :disabled="currentPage === 1"
          color="blue-darken-1"
          variant="flat"
          :size="isMobile ? 'small' : 'default'"
          @click="currentPage--"
          class="nav-btn"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        
        <div class="page-display">
          <v-chip color="blue-darken-1" variant="flat" :size="isMobile ? 'small' : 'default'">
            {{ currentPage }} / {{ totalPages }}
          </v-chip>
        </div>
        
        <v-btn
          :disabled="currentPage === totalPages"
          color="blue-darken-1"
          variant="flat"
          :size="isMobile ? 'small' : 'default'"
          @click="currentPage++"
          class="nav-btn"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        
        <v-btn
          :disabled="currentPage === totalPages"
          color="blue-darken-1"
          variant="flat"
          :size="isMobile ? 'small' : 'default'"
          @click="currentPage = totalPages"
          class="nav-btn"
        >
          <v-icon>mdi-page-last</v-icon>
        </v-btn>
      </div>
      
      <!-- Informações de Itens -->
      <div v-if="!isMobile" class="text-center mt-2">
        <span class="text-caption text-grey">
          Exibindo {{ startCardItem }}-{{ endCardItem }} de {{ filteredAparelhos.length }} aparelhos
        </span>
      </div>
    </v-card-text>
  </v-card>
</div>

      <!-- Mensagem quando não há resultados -->
      <v-card v-if="filteredAparelhos.length === 0" class="no-results-card" elevation="2">
        <v-card-text class="text-center pa-8">
          <v-avatar size="64" color="grey-lighten-3" class="mb-4">
            <v-icon size="32" color="grey">mdi-magnify-close</v-icon>
          </v-avatar>
          <div class="text-h6 mb-2">Nenhum aparelho encontrado</div>
          <div class="text-body-2 text-grey mb-4">
            Tente ajustar os filtros ou termos de busca
          </div>
          <v-btn color="primary" variant="outlined" @click="limparFiltros">
            Limpar Filtros
          </v-btn>
        </v-card-text>
      </v-card>
    </div>

    <!-- ✅ MODAIS (mantidos iguais) -->
    
    <!-- Modal de Carregamento -->
    <v-dialog v-model="loadingDialog" persistent max-width="400">
      <v-card class="loading-card">
        <v-card-text class="text-center pa-6">
          <v-progress-circular 
            indeterminate 
            color="blue-darken-1" 
            size="48"
            width="4"
            class="mb-4"
          ></v-progress-circular>
          <div class="text-h6 font-weight-medium mb-2">Processando...</div>
          <div class="text-body-2 text-grey">Carregando aparelhos...</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal de Detalhes do Aparelho (mantido igual ao anterior) -->
    <v-dialog
      v-model="deviceModalVisible"
      max-width="800"
      persistent
      scrollable
      class="device-details-dialog"
    >
      <v-card class="device-details-card">
        <!-- Header do Modal -->
        <v-card-title class="device-modal-header pa-4 bg-blue-darken-1 text-white">
          <div class="d-flex align-center w-100">
            <v-avatar size="48" color="white" class="mr-4">
              <v-icon color="white" size="24">mdi-router-wireless</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <div class="text-h5 font-weight-bold">
                {{ selectedDevice?.descricao_aparelho || 'Detalhes do Aparelho' }}
              </div>
              <div class="text-body-2 opacity-90">
                APR{{ formatId(selectedDevice?.id_aparelho) }}
              </div>
            </div>
            <v-btn
              icon
              variant="text"
              color="white"
              @click="closeDeviceModal"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <!-- Conteúdo do Modal -->
        <v-card-text class="pa-6 bg-white" v-if="selectedDevice">
          <v-row>
            <!-- Informações Básicas -->
            <v-col cols="12">
              <div class="section-header mb-4">
                <v-icon color="blue-darken-1" class="mr-2">mdi-information</v-icon>
                <span class="text-h6 font-weight-bold text-blue-darken-1">Informações Básicas do Aparelho</span>
              </div>
            </v-col>

            <!-- ✅ NOVA SEÇÃO PARA FOTOS DO TIPO -->
<v-col cols="12" v-if="selectedDevice?.id_tipo_aparelho">
  <v-divider class="my-4"></v-divider>
  <div class="section-header mb-4">
    <v-icon color="purple" class="mr-2">mdi-camera</v-icon>
    <span class="text-h6 font-weight-bold text-purple">Fotos do Tipo de Aparelho</span>
  </div>
  
  <v-card variant="outlined" class="photos-preview-card">
    <v-card-text class="pa-4">
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="purple" class="mr-2">mdi-image-multiple</v-icon>
          <span class="text-body-1">{{ selectedDevice.tipo_aparelho }}</span>
        </div>
        <v-btn
          color="purple"
          variant="flat"
          size="small"
          @click="verFotosTipoAparelho(selectedDevice)"
          :loading="loadingFotos[selectedDevice?.id_tipo_aparelho] === true"
        >
          <v-icon start size="18">mdi-camera</v-icon>
          Ver Fotos Completas
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</v-col>


            <v-col cols="12" md="6">
              <v-card variant="outlined" class="detail-card">
                <v-card-text class="pa-4">
                  <div class="detail-label">ID do Aparelho</div>
                  <div class="detail-value">
                    <v-chip color="blue-darken-1" variant="flat" class="text-white">
                      APR{{ formatId(selectedDevice.id_aparelho) }}
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card variant="outlined" class="detail-card">
                <v-card-text class="pa-4">
                  <div class="detail-label">Status</div>
                  <div class="detail-value">
                    <v-chip 
                      :color="selectedDevice.disponivel === 'SIM' ? 'success' : 'error'"
                      variant="flat"
                      class="text-white"
                    >
                      <v-icon start>
                        {{ selectedDevice.disponivel === 'SIM' ? 'mdi-check-circle' : 'mdi-close-circle' }}
                      </v-icon>
                      {{ selectedDevice.disponivel === 'SIM' ? 'Disponível' : 'Indisponível' }}
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card variant="outlined" class="detail-card">
                <v-card-text class="pa-4">
                  <div class="detail-label">Tipo de Aparelho</div>
                  <div class="detail-value">
                    <v-chip color="blue-lighten-1" variant="tonal" class="text-blue-darken-3">
                      {{ selectedDevice.tipo_aparelho || 'Não especificado' }}
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card variant="outlined" class="detail-card">
                <v-card-text class="pa-4">
                  <div class="detail-label">Número de Série</div>
                  <div class="detail-value">{{ selectedDevice.numero_serie || 'Não informado' }}</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card variant="outlined" class="detail-card">
                <v-card-text class="pa-4">
                  <div class="detail-label">Marca</div>
                  <div class="detail-value">{{ selectedDevice.marca || 'Não informado' }}</div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card variant="outlined" class="detail-card">
                <v-card-text class="pa-4">
                  <div class="detail-label">Modelo</div>
                  <div class="detail-value">{{ selectedDevice.modelo || 'Não informado' }}</div>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Informações da Máquina (se houver) -->
            <template v-if="selectedDevice.id_maquina">
              <v-col cols="12">
                <v-divider class="my-4"></v-divider>
                <div class="section-header mb-4">
                  <v-icon color="blue-darken-1" class="mr-2">mdi-cog</v-icon>
                  <span class="text-h6 font-weight-bold text-blue-darken-1">Máquina Vinculada</span>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <v-card variant="outlined" class="detail-card machine-card">
                  <v-card-text class="pa-4">
                    <div class="detail-label">ID da Máquina</div>
                    <div class="detail-value">
                      <v-chip color="blue-darken-1" variant="flat" class="text-white">
                        MAQ{{ formatId(selectedDevice.id_maquina) }}
                      </v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="6">
                <v-card variant="outlined" class="detail-card machine-card">
                  <v-card-text class="pa-4">
                    <div class="detail-label">Setor</div>
                    <div class="detail-value">
                      <v-chip color="green-lighten-1" variant="tonal" class="text-green-darken-3">
                        {{ selectedDevice.setor || 'Não especificado' }}
                      </v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col v-if="selectedDevice.fila || selectedDevice.posicao" cols="12">
                <v-card variant="outlined" class="detail-card machine-card">
                  <v-card-text class="pa-4">
                    <div class="detail-label">Localização</div>
                    <div class="detail-value">
                      <v-chip color="blue-grey-lighten-4" variant="tonal" class="text-blue-grey-darken-3">
                        <v-icon start color="blue-grey-darken-2">mdi-map-marker</v-icon>
                        Fila {{ selectedDevice.fila || "-" }} / Posição {{ selectedDevice.posicao || "-" }}
                      </v-chip>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>

            <!-- Sem Máquina Associada -->
            <template v-else>
              <v-col cols="12">
                <v-divider class="my-4"></v-divider>
                <v-card variant="outlined" class="no-machine-card">
                  <v-card-text class="text-center pa-6">
                    <v-avatar size="64" color="grey-lighten-3" class="mb-4">
                      <v-icon size="32" color="grey">mdi-link-off</v-icon>
                    </v-avatar>
                    <div class="text-h6 mb-2">Sem máquina associada</div>
                    <div class="text-body-2 text-grey">
                      Este aparelho não está vinculado a nenhuma máquina
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </template>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Ações do Modal -->
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>

          


          <v-btn
            v-if="selectedDevice?.id_maquina"
            color="primary"
            variant="flat"
            @click="openMachineFromDevice"
            class="mr-2"
          >
            <v-icon start>mdi-eye</v-icon>
            Ver Máquina
          </v-btn>
          <v-btn
            color="grey"
            variant="outlined"
            @click="closeDeviceModal"
          >
            <v-icon start>mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Detalhes da Máquina -->
    <ComponenteMaquinaDialog
      :idMaquina="selectedMachineId"
      :ativa="machineModalVisible"
      :habilitarSelecao="false"
      @update:ativa="machineModalVisible = $event"
      @close="closeMachineModal"
      @maquina-selecionada="handleMaquinaSelecionada"
    />
  </div>
</template>

<script>
import ComponenteMaquinaDialog from "@/components/ComponenteMaquinaDialog.vue";
import ImagemTipoAparelho from "@/components/ImagemTipoAparelho.vue"; // ✅ ADICIONAR ESTA LINHA

import { aparelhoService } from "@/services/aparelhoService";
import { useDisplay } from 'vuetify';

export default {
  name: 'ConsultaAparelhos',
  
  components: {
    ComponenteMaquinaDialog,
    ImagemTipoAparelho, // ✅ ADICIONAR ESTA LINHA


  },

  data() {
    return {
      // Estados principais
      aparelhos: [],
      loadingDialog: false,
      
      // ESTADOS PARA FOTOS DO TIPO DE APARELHO
      tiposComFotos: {}, // Cache das fotos carregadas
      loadingFotos: {}, // Loading por tipo
      fotosModalVisible: false, // Controle de visibilidade do modal
      tipoAparelhoSelecionado: null, // Dados do tipo de aparelho selecionado

      // CONTROLE DOS FILTROS EXPANSÍVEIS
      filtersExpanded: true,
      
      // MODAL STATES
      machineModalVisible: false,
      selectedMachineId: null,
      deviceModalVisible: false,
      selectedDevice: null,
      
      // Filtros e pesquisa
      search: "",
      filtroTipoAparelho: null,
      filtroIdTipoAparelho: null,
      filtroTipoMaquina: null,
      filtroDisponivel: null,
      filtroSetor: null,
      
      // ✅ VISUALIZAÇÃO E PAGINAÇÃO
      viewMode: "table",
      currentPage: 1,
      itemsPerPage: 10, // ✅ 10 registros por página
      
      // Headers da tabela
      headers: [
        { title: "ID", key: "id_aparelho", sortable: true },
        { title: "Id Tipo Aparelho", key: "id_tipo_aparelho", sortable: true },
        { title: "Descrição", key: "descricao_aparelho", sortable: true },
        { title: "Tipo", key: "tipo_aparelho", sortable: true },
        { title: "Status", key: "disponivel", sortable: true },
        { title: "Máquina", key: "id_maquina", sortable: true },
        { title: "Setor", key: "setor", sortable: true },
        { title: "Marca", key: "marca", sortable: true },
        { title: "Modelo", key: "modelo", sortable: true },
        { title: "Ações", key: "actions", sortable: false, align: "center" },
      ],
    };
  },

  computed: {


  // ✅ CÁLCULOS PARA CARDS
  startCardItem() {
    return ((this.currentPage - 1) * this.itemsPerPage) + 1;
  },

  endCardItem() {
    const end = this.currentPage * this.itemsPerPage;
    return end > this.filteredAparelhos.length ? this.filteredAparelhos.length : end;
  },

    isMobile() {
      const { xs, sm, md } = useDisplay();
      return xs.value && !sm.value && !md.value;
    },

    // ✅ CONTROLE DE FILTROS ATIVOS
    hasActiveFilters() {
      return !!(this.search || this.filtroIdTipoAparelho || this.filtroTipoAparelho || this.filtroTipoMaquina || 
                this.filtroDisponivel || this.filtroSetor);
    },

    activeFiltersCount() {
      let count = 0;
      if (this.search) count++;
      if (this.filtroIdTipoAparelho) count++;
      if (this.filtroTipoAparelho) count++;
      if (this.filtroTipoMaquina) count++;
      if (this.filtroDisponivel) count++;
      if (this.filtroSetor) count++;
      return count;
    },

    // ✅ ALTURA DINÂMICA
    dynamicCardsHeight() {

          if (this.isMobile) {
      return 'calc(100vh - 200px)';   // Linha adicionada: altura reduzida no mobile
    }

      if (this.filtersExpanded) {
        return 'calc(100vh - 450px)';
      } else {
        return this.hasActiveFilters ? 'calc(100vh - 320px)' : 'calc(100vh - 280px)';
      }
    },

    idsTipoAparelho() {
      return [...new Set(this.aparelhos.map(item => item.id_tipo_aparelho).filter(Boolean))].sort((a, b) => a - b);
    },

    tiposDeAparelho() {
      return [...new Set(this.aparelhos.map(item => item.tipo_aparelho || "Não especificado"))];
    },

    tiposDeMaquina() {
      return [...new Set(this.aparelhos.map(item => item.tipo_maquinas || "Não especificado"))];
    },

    setores() {
      return [...new Set(this.aparelhos.map(item => item.setor || "Não especificado"))];
    },

    filteredAparelhos() {
      return this.aparelhos.filter((aparelho) => {
        const searchTerm = this.search?.toLowerCase().trim() || "";
        const tipoAparelho = aparelho.tipo_aparelho || "Não especificado";
        const tipoMaquina = aparelho.tipo_maquinas || "Não especificado";
        const setor = aparelho.setor || "Não especificado";

        // Busca geral
        const matchSearch = !this.search || (
          aparelho.descricao_aparelho?.toLowerCase().includes(searchTerm) ||
          tipoAparelho.toLowerCase().includes(searchTerm) ||
          aparelho.marca?.toLowerCase().includes(searchTerm) ||
          aparelho.modelo?.toLowerCase().includes(searchTerm) ||
          aparelho.numero_serie?.toLowerCase().includes(searchTerm) ||
          aparelho.id_aparelho?.toString().includes(searchTerm)
        );

        const matchIdTipoAparelho = !this.filtroIdTipoAparelho || aparelho.id_tipo_aparelho === this.filtroIdTipoAparelho;
        const matchTipoAparelho = !this.filtroTipoAparelho || tipoAparelho === this.filtroTipoAparelho;
        const matchTipoMaquina = !this.filtroTipoMaquina || tipoMaquina === this.filtroTipoMaquina;
        const matchDisponivel = !this.filtroDisponivel || aparelho.disponivel === this.filtroDisponivel;
        const matchSetor = !this.filtroSetor || setor === this.filtroSetor;

        return matchSearch && matchIdTipoAparelho && matchTipoAparelho && matchTipoMaquina && matchDisponivel && matchSetor;
      });
    },

    // ✅ PAGINAÇÃO PARA CARDS
    totalPages() {
      return Math.ceil(this.filteredAparelhos.length / this.itemsPerPage);
    },

    paginatedCardItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredAparelhos.slice(start, end);
    },
  },

  watch: {
    filteredAparelhos() {
      this.currentPage = 1; // Reset para primeira página quando filtros mudam
    },

    itemsPerPage() {
      this.currentPage = 1; // Reset quando muda itens por página
    },
  },

  methods: {

  // ✅ MÉTODO PARA CARREGAR FOTOS DO TIPO
  async carregarFotosTipo(idTipoAparelho) {
    if (this.tiposComFotos[idTipoAparelho]) {
      return this.tiposComFotos[idTipoAparelho]; // Já carregado
    }

    try {
      this.loadingFotos[idTipoAparelho] = true;
      console.log('🔍 Carregando fotos do tipo:', idTipoAparelho);
      
      const tipoComFotos = await aparelhoService.obterTipoComFotos(idTipoAparelho);
      
      // Salvar no cache
      this.tiposComFotos[idTipoAparelho] = tipoComFotos;
      
      return tipoComFotos;
      
    } catch (error) {
      console.error('❌ Erro ao carregar fotos:', error);
      this.$toast.error('Erro ao carregar fotos do tipo de aparelho');
      return null;
    } finally {
      this.loadingFotos[idTipoAparelho] = false;
    }
  },
  
  // ✅ MÉTODO PARA ABRIR MODAL DE FOTOS
  async verFotosTipoAparelho(aparelho) {
    if (!aparelho || !aparelho.id_tipo_aparelho) return;
    
    try {
      // Marcar como carregando para este tipo
      this.loadingFotos = { ...this.loadingFotos, [aparelho.id_tipo_aparelho]: true };
      
      // Carregar fotos do tipo
      const tipoComFotos = await this.carregarFotosTipo(aparelho.id_tipo_aparelho);
      
      if (!tipoComFotos) {
        this.$toast.error('Não foi possível carregar as fotos deste tipo de aparelho');
        return;
      }
      
      // Adicionar informação sobre aparelho atual para o modal
      tipoComFotos.aparelho_atual = aparelho;
      
      // Guardar no estado e abrir modal
      this.tipoAparelhoSelecionado = tipoComFotos;
      this.fotosModalVisible = true;
      
      console.log('✅ Modal de fotos aberto para tipo:', tipoComFotos.descricao_tipo);
      
    } catch (error) {
      console.error('❌ Erro ao abrir fotos do tipo:', error);
      this.$toast.error('Erro ao abrir galeria de fotos');
    } finally {
      // Desmarcar carregando
      if (aparelho && aparelho.id_tipo_aparelho) {
        this.loadingFotos = { ...this.loadingFotos, [aparelho.id_tipo_aparelho]: false };
      }
    }
  },
  
  // ✅ MÉTODO PARA FECHAR MODAL DE FOTOS
  fecharModalFotos() {
    this.fotosModalVisible = false;
    console.log('🚪 Modal de fotos fechado');
    
    // Limpar após um breve delay para permitir a animação
    setTimeout(() => {
      this.tipoAparelhoSelecionado = null;
    }, 300);
  },


    // ========================================
    // ✅ MÉTODOS DOS FILTROS EXPANSÍVEIS
    // ========================================

    toggleFilters() {
      this.filtersExpanded = !this.filtersExpanded;
    },

    // ========================================
    // MÉTODOS PRINCIPAIS
    // ========================================

    formatId(id) {
      return id ? String(id).padStart(3, '0') : "000";
    },

    async fetchData() {
      this.loadingDialog = true;
      
      try {
        const response = await aparelhoService.obterTodos();
        this.aparelhos = Array.isArray(response) ? response : [];
        
        // Garantir valores padrão
        this.aparelhos = this.aparelhos.map(item => ({
          ...item,
          tipo_aparelho: item.tipo_aparelho || "Não especificado",
          tipo_maquinas: item.tipo_maquinas || "Não especificado",
          setor: item.setor || "Não especificado",
          descricao_aparelho: item.descricao_aparelho || "Sem descrição",
        }));
      } catch (error) {
        console.error("Erro ao buscar aparelhos:", error);
        this.aparelhos = [];
      } finally {
        this.loadingDialog = false;
      }
    },

    voltarMenu() {
      this.$router.push({ name: 'MenuDefault' }).catch(() => {});
    },

    limparFiltros() {
      this.search = "";
      this.filtroIdTipoAparelho = null;
      this.filtroTipoAparelho = null;
      this.filtroTipoMaquina = null;
      this.filtroDisponivel = null;
      this.filtroSetor = null;
      this.currentPage = 1;
    },

    // ========================================
    // ✅ MÉTODOS DE MODAL
    // ========================================

    openMachineModal(item) {
      this.selectedMachineId = item.id_maquina;
      this.machineModalVisible = true;
    },

    closeMachineModal() {
      this.machineModalVisible = false;
      this.selectedMachineId = null;
    },

    handleMaquinaSelecionada(maquina) {
      console.log("Máquina selecionada:", maquina);
      this.machineModalVisible = false;
    },

    // ✅ MÉTODOS DO MODAL DE APARELHO
    openDeviceModal(aparelho) {
      this.selectedDevice = aparelho;
      this.deviceModalVisible = true;
    },

    closeDeviceModal() {
      this.deviceModalVisible = false;
      this.selectedDevice = null;
    },

    openMachineFromDevice() {
      if (this.selectedDevice?.id_maquina) {
        this.closeDeviceModal();
        this.selectedMachineId = this.selectedDevice.id_maquina;
        this.machineModalVisible = true;
      }
    },
  },

  created() {
    this.fetchData();
  },
};
</script>


<style scoped>
/* ✅ ESTILOS BÁSICOS */
.aparelhos-container {
  padding: 24px;
  background: #e4edfb;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 12px;
}

.back-btn {
  font-weight: 600;
  border-radius: 8px;
}

/* ✅ FILTROS E HEADER OTIMIZADO */
.filters-card {
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.filters-header {
  background: linear-gradient(135deg, #4985c1 0%, #5688c1 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.filters-header:hover {
  background: linear-gradient(135deg, #4985c1 0%, #5688c1 100%);
  transform: translateY(-1px);
  box-shadow: 0 2px 12px rgba(25, 118, 210, 0.3);
}

.filters-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1976d2;
}

.cursor-pointer {
  cursor: pointer;
}

/* ✅ ESTILOS DA TABELA */
.custom-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e0e0e0;
  background: #ffffff;
}

.table-header {
  background: #1e88e5;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  font-size: 0.7rem;
  letter-spacing: 0.5px;
  height: 48px;
}

.table-header th {
  color: white !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px;
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row:hover {
  background-color: #f5f9ff !important;
}

.table-row:nth-of-type(odd) {
  background-color: #ffffff;
}

.table-row:nth-of-type(even) {
  background-color: #f8fafd;
}

.table-row td {
  padding: 12px 16px !important;
  color: #37474f;
  font-size: 0.875rem;
  border-bottom: 1px solid #f0f0f0;
}

.table-row a {
  color: #1e88e5;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.table-row a:hover {
  color: #1565c0;
  text-decoration: underline;
}

/* ✅ CARDS DE APARELHOS */
.device-card {
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e0e0e0;
  position: relative;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 16px;
}

.device-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;
  border-color: #bbdefb;
}

.device-card-header {
  background: #f8fafc;
  border-bottom: 1px solid #eef2f6;
  padding: 14px 16px;
  min-height: 64px;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.device-card:hover .device-card-header {
  background: #f1f5f9;
}

.device-status {
  position: absolute;
  top: 12px;
  right: 12px;
  font-size: 0.675rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.status-active {
  background: #e8f5e9;
  color: #1b5e20;
  border-left: 3px solid #43a047;
}

.status-inactive {
  background: #ffebee;
  color: #c62828;
  border-left: 3px solid #e53935;
}

.status-maintenance {
  background: #fff3e0;
  color: #e65100;
  border-left: 3px solid #fb8c00;
}

/* ✅ SEÇÃO DE DETALHES */
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1);
  color: #1e88e5;
  font-weight: 600;
}

.section-header .v-icon {
  margin-right: 8px;
  color: #1e88e5;
}

.info-card {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background: #ffffff;
  transition: all 0.2s ease;
  margin-bottom: 16px;
  overflow: hidden;
}

.info-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border-color: #bbdefb;
}

.info-card .v-card-text {
  padding: 16px;
}

.info-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #546e7a;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.info-value {
  font-size: 0.95rem;
  font-weight: 500;
  color: #263238;
  word-break: break-word;
}

.status-chip {
  font-weight: 500;
  letter-spacing: 0.3px;
  padding: 0 10px;
  height: 26px;
  font-size: 0.75rem;
}

.machine-card {
  border-left: 4px solid #1e88e5;
  background-color: #f8fafd;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.machine-card:hover {
  background-color: #f1f7ff;
  box-shadow: 0 2px 8px rgba(30, 136, 229, 0.1);
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #78909c;
}

.empty-state .v-icon {
  font-size: 64px;
  margin-bottom: 16px;
  color: #cfd8dc;
}

.empty-state h3 {
  font-weight: 500;
  margin-bottom: 8px;
  color: #546e7a;
}

.empty-state p {
  color: #90a4ae;
  max-width: 400px;
  margin: 0 auto;
}

/* ✅ MENU MOBILE */
.v-menu .v-list {
  min-width: 120px;
}

.v-menu .v-list-item {
  min-height: 40px;
}

/* ✅ ANIMAÇÕES */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.device-card:nth-child(1) { animation-delay: 0.1s; }
.device-card:nth-child(2) { animation-delay: 0.2s; }
.device-card:nth-child(3) { animation-delay: 0.3s; }
.device-card:nth-child(4) { animation-delay: 0.4s; }

/* ✅ TRANSIÇÕES DE EXPANSÃO */
.v-expand-transition-enter-active,
.v-expand-transition-leave-active {
  transition: all 0.3s ease;
}

.v-expand-transition-enter-from,
.v-expand-transition-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* ✅ CUSTOMIZAÇÃO DOS CHIPS */
.v-chip.v-chip--size-small {
  font-size: 0.75rem;
  height: 24px;
}

.v-chip.v-chip--size-x-small {
  font-size: 0.625rem;
  height: 20px;
}

/* ✅ TIPOGRAFIA */
.text-h6 {
  line-height: 1.3;
}

/* ✅ BORDAS ARREDONDADAS CONSISTENTES */
.v-card,
.v-btn,
.v-text-field,
.v-select {
  border-radius: 8px !important;
}

.filters-card,
.table-card,
.no-results-card {
  border-radius: 12px !important;
}

/* ✅ TRANSIÇÕES GLOBAIS */
* {
  transition: all 0.2s ease;
}

/* ✅ FOCUS STATES */
.v-text-field:focus-within,
.v-select:focus-within {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.v-btn:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

/* ✅ RESPONSIVIDADE */
@media (max-width: 768px) {
  .aparelhos-container {
    padding: 16px;
  }
  
  .page-header .d-flex {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 16px;
  }
  
  .back-btn {
    align-self: stretch;
  }
  
  .filters-header {
    min-height: auto;
    padding: 12px 16px !important;
  }
  
  .filters-header .d-flex {
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .filters-title {
    font-size: 1rem;
  }
  
  .v-chip.v-chip--size-small {
    font-size: 0.625rem;
    height: 20px;
  }
  
  .device-card {
    margin-bottom: 16px;
  }
  
  .cards-scroll-area {
    max-height: calc(100vh - 300px) !important;
  }
  
  .cards-scroll-area::-webkit-scrollbar {
    width: 4px;
  }
  
  .device-details-card {
    margin: 8px;
    max-height: calc(100vh - 32px);
  }
  
  .detail-card {
    margin-bottom: 12px;
  }
  
  .section-header {
    flex-direction: column;
    text-align: center;
    gap: 8px;
  }
  
  .mobile-quick-nav .v-btn {
    font-size: 0.875rem;
    padding: 8px 16px;
  }
  
  .nav-btn {
    min-width: 44px;
    height: 44px;
  }
  
  .floating-nav {
    bottom: 24px;
  }
}

@media (max-width: 600px) {
  .filters-header .d-flex {
    flex-direction: column;
    align-items: flex-start !important;
  }
  
  .filters-header .d-flex > div:first-child {
    width: 100%;
    justify-content: space-between;
  }
  
  .filters-header .d-flex > div:nth-child(2) {
    width: 100%;
    justify-content: flex-start;
    margin-top: 8px;
  }
}

@media (min-width: 960px) {
  .detail-card {
    min-height: 100px;
  }
}

/* ✅ PRINT STYLES */
@media print {
  .filters-card,
  .pagination-container {
    display: none;
  }
  
  .device-card {
    break-inside: avoid;
    margin-bottom: 16px;
  }
  
  .device-details-card {
    box-shadow: none;
    border: 1px solid #ddd;
  }
}

/* ✅ BOTÕES E CONTROLES COMPACTOS - VERSÃO FINAL */
.compact-btn {
  min-width: auto !important;
  height: 36px !important;
  padding: 0 16px !important;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.02em;
  border-radius: 6px;
  transition: all 0.2s ease;
  background-color: white !important;
  border: 1px solid #dee2e6 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  margin: 0 4px;
}

.compact-btn:hover:not(:disabled) {
  background-color: #f8f9fa !important;
  border-color: #adb5bd !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.compact-btn:disabled {
  background-color: #f8f9fa !important;
  border-color: #e9ecef !important;
  opacity: 0.6;
  cursor: not-allowed;
}

.compact-btn:disabled:hover {
  transform: none !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

.compact-toggle {
  height: 36px;
  border-radius: 6px;
  overflow: hidden;
  background-color: white;
  border: 1px solid #dee2e6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.compact-toggle .v-btn {
  min-width: 40px !important;
  height: 36px !important;
  padding: 0 12px !important;
  font-size: 0.8rem;
  font-weight: 500;
  background-color: #ffffff !important;
  color: #6c757d !important;
  border: none !important;
  transition: all 0.2s ease;
}

.compact-toggle .v-btn:hover:not(.v-btn--active) {
  background-color: #f8f9fa !important;
  color: #495057 !important;
}

/* ✅ PAGINAÇÃO */
.pagination-container {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ✅ BARRA DE NAVEGAÇÃO FIXA */
.fixed-pagination-footer {
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 0 16px;
  background-color: transparent;
}

.pagination-card {
  background-color: rgb(166, 207, 236);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2) !important;
  border: 1px solid rgba(25, 118, 210, 0.1);
  transition: all 0.3s ease;
}

.nav-btn {
  min-width: 40px;
  height: 40px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.nav-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.page-display {
  padding: 0 8px;
}

/* Ajustes para modo desktop e mobile */
@media (min-width: 769px) {
  .fixed-pagination-footer {
    padding: 12px 24px;
  }
  
  .nav-btn {
    min-width: 48px;
    height: 48px;
  }
  
  .page-display {
    padding: 0 16px;
  }
}

@media (max-width: 768px) {
  .fixed-pagination-footer {
    padding: 8px;
  }
  
  .pagination-card {
    border-radius: 8px;
  }
  
  .nav-btn {
    min-width: 36px;
    height: 36px;
  }
}

.compact-toggle .v-btn--active {
  background-color: #495057 !important;
  color: white !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

/* ✅ ESPAÇAMENTO ENTRE ELEMENTOS */
.gap-3 > * + * {
  margin-left: 12px;
}

/* ✅ RESPONSIVIDADE DOS BOTÕES */
@media (max-width: 768px) {
  .compact-btn {
    height: 32px !important;
    padding: 0 12px !important;
    font-size: 0.75rem;
    margin: 0 2px;
  }
  
  .gap-3 > * + * {
    margin-left: 8px;
  }
  
  .compact-toggle {
    margin-left: 8px !important;
    height: 32px;
  }
  
  .compact-toggle .v-btn {
    height: 32px !important;
    padding: 0 8px !important;
  }
}
/* ✅ CONTROLES RESPONSIVOS */
.controls-section {
  transition: all 0.3s ease;
}

.mobile-controls {
  margin-left: auto;
}

/* ✅ BOTÕES MOBILE */
.mobile-btn {
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  background-color: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2) !important;
  margin: 0 2px;
  border-radius: 6px;
}

.mobile-btn:hover:not(:disabled) {
  background-color: rgba(255, 255, 255, 1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25) !important;
}

.mobile-btn:disabled {
  background-color: rgba(255, 255, 255, 0.6) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  opacity: 0.5;
}

/* ✅ CHIPS DE STATUS MOBILE */
.mobile-status-chips {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
}

.mobile-status-chips .v-chip {
  font-size: 0.625rem;
  height: 20px;
  background-color: rgba(255, 255, 255, 0.9) !important;
  color: #546e7a !important;
}

/* ✅ MENU MOBILE */
.mobile-menu {
  min-width: 140px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.mobile-menu .v-list-item {
  min-height: 40px;
  padding: 8px 16px;
}

.mobile-menu .v-list-item-title {
  font-size: 0.875rem;
  font-weight: 500;
}

/* ✅ EXPAND BUTTON RESPONSIVO */
.expand-btn {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}

.expand-btn:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

/* ✅ RESPONSIVIDADE MELHORADA */
@media (max-width: 768px) {
  .filters-header {
    padding: 12px 16px !important;
  }
  
  .filters-title {
    font-size: 0.95rem;
  }
  
  .quick-filters-bar {
    padding: 8px 12px !important;
  }
  
  .quick-filters-bar .d-flex {
    gap: 4px !important;
  }
  
  .quick-filters-bar .v-chip {
    margin: 1px;
    font-size: 0.625rem;
  }
}

@media (max-width: 480px) {
  .filters-header {
    padding: 8px 12px !important;
  }
  
  .filters-title {
    font-size: 0.875rem;
  }
  
  .mobile-btn {
    min-width: 28px !important;
    width: 28px !important;
    height: 28px !important;
  }
  
  .mobile-status-chips {
    padding: 4px 8px !important;
  }
}

/* ✅ ANIMAÇÕES SUAVES */
.mobile-btn,
.expand-btn {
  transition: all 0.2s ease;
}

.rotate-180 {
  transform: rotate(180deg);
}

.cards-scroll-area {
  overflow-y: auto;                   /* Linha adicionada */
  -webkit-overflow-scrolling: touch;   /* Linha adicionada */
}

/* Ajuste específico para mobile: reduzir a altura para caber na viewport */
@media (max-width: 768px) {
  .cards-scroll-area {
    max-height: calc(100vh - 200px);  /* Linha alterada: menos pixels subtraídos */
  }
}
 

</style>